import { render, staticRenderFns } from "./bottom-bar.vue?vue&type=template&id=c78e8eba&scoped=true"
import script from "./bottom-bar.vue?vue&type=script&lang=js"
export * from "./bottom-bar.vue?vue&type=script&lang=js"
import style0 from "./bottom-bar.vue?vue&type=style&index=0&id=c78e8eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78e8eba",
  null
  
)

export default component.exports